export default {
  isIOS: () => navigator.userAgent.match(/(iPad|iPhone|iPod)/i),
  isAndroid: () => navigator.userAgent.match(/android/i),
  isSafari: () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}
